export default class MosaicContentDropdown {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.mosaic-content-dropdown'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	#holderElement;

	/** @type {HTMLElement} */
	#dropdown;

	/** @type {Boolean} */
	#isOpen = false;

	/** @type {String} */
	#currentFeatureIconElement;

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		this.#dropdown = this.#holderElement.querySelector('.mosaic-content-dropdown-content');
		if (this.#dropdown) {
			this.#dropdown.style.height = '0px';
		}
		this.#holderElement.querySelectorAll('.toggle')
			.forEach(e => e.addEventListener('click', this.#toggle.bind(this)));
		this.#positionDropdown();
	}

	/**
	 * @return {string}
	 */
	#height() {
		let gridGap = window.innerWidth > 480 ? 20.8 : 0;
		return this.#dropdown.querySelector('.height-wrapper').scrollHeight + gridGap + 'px';
	}

	#toggle() {
		this.#closeOthers();
		const isOpen = this.#dropdown.style.height !== '0px';
		this.#dropdown.style.height = (isOpen) ? '0px' : this.#height();
		if (window.innerWidth <= 480) this.#dropdown.style.marginBottom = (isOpen) ? '0px' : '1.3rem';
		// if (this.#dropdown.style.height !== '0px') {
		// 	this.#scrollToDropdown();
		// }
		let y = window.innerWidth >= 992 ? 170 : 169.17;
		let pos = this.#dropdown.style.position;
		let top = this.#dropdown.style.top;
		this.#dropdown.style.position = 'relative';
		this.#dropdown.style.top = (y * -1).toString() + 'px';
		this.#dropdown.scrollIntoView({behavior: 'smooth', block: 'start'});
		this.#dropdown.style.top = top;
		this.#dropdown.style.position = pos;
		this.#setActiveFeature();
	}

	#closeOthers() {
		document.querySelectorAll('.mosaic-content-dropdown-content').forEach(e => {
			if (!e.isEqualNode(this.#dropdown)) {
				e.style.height = '0px';
				e.style.marginBottom = '0px';
			}
		});
	}

	#positionDropdown() {
		const element = document.createElement('div');
		element.classList.add('row', 'outer-row');
		element.innerHTML = '<div class="col"></div>';
		element.querySelector('.col').append(this.#dropdown);
		this.#holderElement
			.closest('.outer-row')
			.after(element);
	}

	#setActiveFeature() {
		this.#currentFeatureIconElement = '<img src="' + window.config.themeDirectory + '/images/svg/arrow-left-dark.svg" alt="Current feature" class="current-dropdown-feature-icon">';
		document.querySelectorAll('.mosaic-content-dropdown-content').forEach(e => {
			if (e.isEqualNode(this.#dropdown)) {
				let firstFeatureItem = e.querySelectorAll('.dropdown-feature-item')[0];
				if (!this.#dropdown.querySelector('.current-dropdown-feature-icon')) {
					// firstFeatureItem.insertAdjacentHTML('beforebegin', this.#currentFeatureIconElement);
					firstFeatureItem.innerHTML = this.#currentFeatureIconElement + firstFeatureItem.innerHTML;
					firstFeatureItem.classList.add('active');
				}
				e.querySelectorAll('.dropdown-feature-item').forEach((featureItem) => {
					if (!featureItem.classList.contains('active')) {
						featureItem.classList.add('collapsed');
					}
					featureItem.addEventListener('click', (event) => {
						this.#dropdown.querySelector('.current-dropdown-feature-icon').remove();
						this.#dropdown.querySelector('.dropdown-feature-item.active').classList.remove('active');
						// featureItem.insertAdjacentHTML('beforebegin', this.#currentFeatureIconElement);
						featureItem.innerHTML = this.#currentFeatureIconElement + featureItem.innerHTML;
						featureItem.classList.remove('collapsed');
						featureItem.classList.add('active');
						setTimeout(() => {
							this.#dropdown.style.height = this.#height();
						}, 300);

						for (const contentItem of this.#dropdown.querySelectorAll('.collapse')) {
							contentItem.classList.remove('show');
						}
					});
				});
			}
		});
	}
}
